import "./OrdersStore.style.css"

// Components
import NavigationBar from "../../../Components/NavigationBar";
import SideBar from "../../../Components/SideBar";

// Function
import formatRupiah from "../../../Function/formatRupiah";
import formatDateTime from "../../../Function/formatDateTime";

// React Bootstrap
import { Button, InputGroup, Form, Badge, Modal, Spinner, Placeholder } from "react-bootstrap";

// React
import React, { useEffect, useState } from "react";

// React Bootstrap Icons
import { Search, Basket2Fill, Plus, Dash, ArchiveFill } from "react-bootstrap-icons";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Axios
import axios from "axios";

// Sweet Alert 2
import Swal from "sweetalert2";

// Assets
import imageLogo from "../../../logo.png";

const PageOrdersStore = () => {
    const navigate = useNavigate();

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [alertMessage, setAlertMessage] = useState({});

    const [accessToken] = useState(localStorage.getItem("accessToken"));
    // const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

    const [productData, setProductData] = useState([]);
    const [productSearch, setProductSearch] = useState("");

    const [chartData, setChartData] = useState([]);
    const [orderDescription, setOrderDescription] = useState("");
    const [orderPayment, setOrderPayment] = useState("cash");
    const [orderStatus, setOrderStatus] = useState("success");

    const [orderDraft, setOrderDraft] = useState([]);
    const [orderData, setOrderData] = useState([]);

    const [draftShow, setDraftShow] = useState(false);
    const [chartShow, setChartShow] = useState({ status: false, draft_id: null });
    const [receiptShow, setReceiptShow] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) return navigate("/");

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/user`).then(() => {}).catch(() => navigate("/"));

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/order-draft/index?search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
                setOrderDraft(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setOrderDraft(err.response.data);
                else setOrderDraft({"message": "Internal Server Error"});
            })

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/product/index`).then((res) => {
                setProductData(res.data);
            }).catch((err) => {
                if (err.status === 404) setProductData(err.response.data);
                else setProductData({"message": "Internal Server Error"});
            })
            
            await setTimeout(() => setIsPageLoading(false), 500);
            return 1;
        }

        fetchData();
    }, [navigate, accessToken]);

    const handleUpdateOrderDraft = async () => {
        if (isLoading) return 1;

        setIsLoading(true);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/order-draft/index?search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
            setOrderDraft(res.data.data);

            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);

            if (err.status === 404) setOrderDraft(err.response.data);
            else setOrderDraft({"message": "Internal Server Error"});
        })
        return 1;
    }

    const handleSearchProducts = async () => {
        if (isLoading) return 1;

        setIsLoading(true);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/product/index?search=${productSearch}`).then((res) => {
            setProductData(res.data);

            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);

            if (err.status === 404) setProductData(err.response.data);
            else setProductData({"message": "Internal Server Error"});
        })
        return 1;
    }
    
    const addProductToChart = (product_id) => {
        if (isLoading) return 1;

        const product = productData?.data?.find(p => p.id === product_id);
        const stock = product?.stock || 0;

        setChartData(prevData => {
            const safePrev = Array.isArray(prevData) ? prevData : [];

            const existingIndex = safePrev.findIndex(item => item.product_id === product_id);

            if (existingIndex !== -1) {
                const updatedData = [...safePrev];
                const existingItem = updatedData[existingIndex];

                // Cek apakah product_quantity sudah mencapai stok
                if ((existingItem.product_quantity || 1) >= stock) {
                    return safePrev; // Tidak tambah lagi
                }

                updatedData[existingIndex] = {
                    ...existingItem,
                    product_quantity: (existingItem.product_quantity || 1) + 1,
                };

                return updatedData;
            } else {
                // Belum ada, hanya tambah jika stok minimal 1
                if (stock <= 0) return safePrev;

                return [
                    ...safePrev,
                    {
                        product_id,
                        product_quantity: 1,
                        product_image: product?.image || "",
                        product_name: product?.name || "",
                        product_price: product?.price || 0
                    }
                ];
            }
        });

        return 1;
    };

    const totalQuantity = chartData.reduce((total, item) => {
        return total + (Number(item.product_quantity) || 0);
    }, 0);

    const calculateTotal = (dataProduct = []) => {
        if (!Array.isArray(dataProduct) || !productData?.data) return 0;

        return dataProduct.reduce((total, item) => {
            const productId = parseInt(Number(item.product_id), 10);
            const quantity = parseInt(Number(item.product_quantity), 10);

            const product = productData?.data?.find(p => p.id === productId);
            const price = product?.price ?? 0;

            return total + quantity * price;
        }, 0);
    };

    const decreaseQuantity = (product_id) => {
        if (isLoading) return 1;

        setChartData(prevData =>
            prevData
            .map(item =>
                Number(item.product_id) === product_id
                ? { ...item, product_quantity: Number(item.product_quantity) - 1 }
                : item
            )
            .filter(item => Number(item.product_quantity) > 0) // Hapus kalau product_quantity jadi 0 atau kurang
        );

        if (!totalQuantity) setChartShow({ status: false, draft_id: chartShow.draft_id });
    };

    const increaseQuantity = (product_id) => {
        if (isLoading) return 1;

        const product = productData?.data?.find(p => p.id === product_id);
        const stock = product?.stock || 0;

        setChartData(prevData =>
            prevData.map(item => {
                if (Number(item.product_id) === product_id) {
                    const currentQty = Number(item.product_quantity) || 1;

                    if (currentQty >= stock) {
                        return item; // Tidak tambah kalau sudah mencapai stok
                    }

                    return { ...item, product_quantity: currentQty + 1 };
                }

                return item;
            })
        );

        if (!totalQuantity) setChartShow({ status: false, draft_id: chartShow.draft_id });
    };

    const handleQuantityChange = (product_id, newQuantity) => {
        if (isLoading) return 1;

        const product = productData?.data?.find(p => p.id === product_id);
        const stock = product?.stock || 0;
        const qty = Number(newQuantity);

        setChartData(prevData => {
            const safePrev = Array.isArray(prevData) ? prevData : [];

            // Jika product_quantity < 1, hapus item
            if (qty < 1) {
                return safePrev.filter(item => Number(item.product_id) !== product_id);
            }

            // Jika product_quantity > stock, batasi
            const adjustedQty = Math.min(qty, stock);

            return safePrev.map(item =>
                Number(item.product_id) === product_id
                    ? { ...item, product_quantity: adjustedQty }
                    : item
            );
        });

        if (!totalQuantity) setChartShow({ status: false, draft_id: chartShow.draft_id });
    };

    const handleOpenDraft = async (data) => {
        if (isLoading) return 1;

        setOrderDescription(data.description || "");
        setOrderPayment(data.payment);
        setOrderStatus(data.status);
        setChartData(data.products);

        setDraftShow(false);
        setChartShow({ status: true, draft_id: data.id });
        return 1;
    }

    const handleSaveDraft = async () => {
        if (isLoading) return 1;

        const errors = {};

        if (orderDescription && orderDescription?.length > 255) {
            errors.description = "Order description must be less than 255 characters!";
        }

        if (!orderPayment) {
            errors.payment = "Order payment is required!";
        }

        if (orderPayment && orderPayment !== "cash" && orderPayment !== "transfer" && orderPayment !== "credit") {
            errors.payment = "Order payment must be cash, transfer, or credit!";
        }

        if (!orderStatus) {
            errors.status = "Order status is required!";
        }

        if (orderStatus && orderStatus !== "success" && orderStatus !== "pending" && orderStatus !== "failed") {
            errors.status = "Order status must be success, pending, or failed!";
        }

        if (Object.keys(errors).length > 0) {
            return setAlertMessage(errors);
        }

        setAlertMessage({});
        setIsLoading(true);
        
        const formData = new FormData();
        formData.append("description", orderDescription);
        formData.append("payment", orderPayment);
        formData.append("status", orderStatus);

        chartData.forEach((item, index) => {
            formData.append(`product[${index}][product_id]`, item.product_id);
            formData.append(`product[${index}][product_image]`, item.product_image);
            formData.append(`product[${index}][product_name]`, item.product_name);
            formData.append(`product[${index}][product_price]`, item.product_price);
            formData.append(`product[${index}][product_quantity]`, item.product_quantity);
        });

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.post(`${process.env.REACT_APP_API_URL}/api/order-draft/${chartShow.draft_id ? "update/" + chartShow.draft_id : "store"}`, formData).then((res) => {
            console.log(res);

            handleUpdateOrderDraft();
            setChartShow({ status: false, draft_id: chartShow.draft_id });

            setOrderDescription("");
            setOrderPayment("cash");
            setOrderStatus("success");
            setChartData([]);

            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);

            if (err?.response?.status === 422) {
                return setAlertMessage(err?.response?.data?.errors);
            } else if (err?.response?.status === 404) {
                return Swal.fire({
                    title: "Oops!",
                    text: err?.response?.data?.message,
                    icon: "error"
                });
            } else {
                console.error(err);

                return Swal.fire({
                    title: "Oops!",
                    text: "Internal server error",
                    icon: "error"
                });
            }
        })
        return 1;
    }

    const handleRemoveDraft = async () => {
        if (isLoading) return 1;

        setChartShow({ status: false, draft_id: chartShow.draft_id });

        Swal.fire({
            title: "Remove Draft",
            text: `Are you sure you want to remove DRAFT#${chartShow.draft_id}?`,
            icon: "question",
            showCancelButton: true
        }).then(async (res) => {
            if (res.isConfirmed) {
                setIsLoading(true);

                axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                axios.defaults.headers.common['Accept'] = `application/json`;
                await axios.delete(`${process.env.REACT_APP_API_URL}/api/order-draft/destroy/${chartShow.draft_id}`).then((res) => {
                    handleUpdateOrderDraft();
                    setChartShow({ status: false, draft_id: null });

                    setOrderDescription("");
                    setOrderPayment("cash");
                    setOrderStatus("success");
                    setChartData([]);

                    setIsLoading(false);
                }).catch((err) => {
                    setIsLoading(false);

                    if (err?.response?.status === 404) {
                        return Swal.fire({
                            title: "Oops!",
                            text: err?.response?.data?.message,
                            icon: "error"
                        });
                    } else {
                        console.error(err);

                        return Swal.fire({
                            title: "Oops!",
                            text: "Internal server error",
                            icon: "error"
                        });
                    }
                })
            }
        })
        return 1;
    }

    const handleResetChart = async () => {
        if (isLoading) return 1;

        setChartShow({ status: false, draft_id: null });

        setOrderDescription("");
        setOrderPayment("cash");
        setOrderStatus("success");
        setChartData([]);
        return 1;
    }

    const handleCheckout = async (draft_id) => {
        if (isLoading) return 1;

        const errors = {};

        if (orderDescription && orderDescription?.length > 255) {
            errors.description = "Order description must be less than 255 characters!";
        }

        if (!orderPayment) {
            errors.payment = "Order payment is required!";
        }

        if (orderPayment && orderPayment !== "cash" && orderPayment !== "transfer" && orderPayment !== "credit") {
            errors.payment = "Order payment must be cash, transfer, or credit!";
        }

        if (!orderStatus) {
            errors.status = "Order status is required!";
        }

        if (orderStatus && orderStatus !== "success" && orderStatus !== "pending" && orderStatus !== "failed") {
            errors.status = "Order status must be success, pending, or failed!";
        }

        if (Object.keys(errors).length > 0) {
            return setAlertMessage(errors);
        }

        setAlertMessage({});
        setChartShow({ status: false, draft_id: null });
        setIsLoading(true);

        Swal.fire({
            title: `Total: ${formatRupiah(calculateTotal(chartData))}`,
            input: "number",
            inputPlaceholder: calculateTotal(chartData),
            showCancelButton: true,
            confirmButtonText: "Create Order",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const valueOrderPaid = Number(result.value);
                
                if (calculateTotal(chartData) > valueOrderPaid && orderPayment !== "credit") {
                    return handleCheckout(draft_id);
                }

                const formData = new FormData();
                if (draft_id) formData.append("draft_id", Number(draft_id));
                formData.append("description", orderDescription);
                formData.append("payment", orderPayment);
                formData.append("status", orderStatus);
                formData.append("down_payment", valueOrderPaid);

                chartData.forEach((item, index) => {
                    formData.append(`product[${index}][id]`, item.product_id);
                    formData.append(`product[${index}][image]`, item.product_image);
                    formData.append(`product[${index}][name]`, item.product_name);
                    formData.append(`product[${index}][price]`, item.product_price);
                    formData.append(`product[${index}][quantity]`, item.product_quantity);
                });

                axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                axios.defaults.headers.common['Accept'] = `application/json`;
                await axios.post(`${process.env.REACT_APP_API_URL}/api/order/store`, formData).then((res) => {
                    setOrderData(res.data.data);

                    setOrderDescription("");
                    setOrderPayment("cash");
                    setOrderStatus("success");
                    setChartData([]);

                    handleSearchProducts();
                    handleUpdateOrderDraft();

                    setReceiptShow(true);
                    setIsLoading(false);
                }).catch((err) => {
                    setIsLoading(false);
                    
                    if (err?.response?.status === 422) {
                        setChartShow({ status: true, draft_id: draft_id });
                        return setAlertMessage(err?.response?.data?.errors);
                    } else {
                        console.error(err);

                        return Swal.fire({
                            title: "Oops!",
                            text: "Internal server error",
                            icon: "error"
                        });
                    }
                })
            } else {
                setChartShow({ status: true, draft_id: draft_id });
                setIsLoading(false);
            }
        })
        return 1;
    }
    
    const handleOrderReceiptPrint = (data) => {
        if (isLoading) return 1;

        localStorage.setItem("orderData", JSON.stringify(data));
        localStorage.setItem("redirectPage", "/orders/store");

        navigate("/orders/print");
        return 1;
    }

    const handleChartShow = (status) => {
        setChartShow({ status: status, draft_id: chartShow.draft_id });
        setAlertMessage({});
        return 1;
    }

    return (
        <section id="orders-store" className="orders-store">
            {/* Navigation Bar */}
            <NavigationBar />

            <div className="content-wrapper">
                {/* Side Bar */}
                <SideBar />

                <div className="contents">
                    {!isPageLoading ? (
                        <>
                            <header>
                                <h4>Orders</h4>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <InputGroup>
                                        <Form.Control type="text" disabled={isLoading} placeholder="Search Products" onChange={(e) => setProductSearch(e.target.value)} />
                                        <Button variant="primary" disabled={isLoading} onClick={handleSearchProducts}><Search /></Button>
                                    </InputGroup>
                                    <Button variant="warning" style={{ height: "37.5px" }} disabled={!orderDraft.length} onClick={() => setDraftShow(true)}>
                                        <span className="d-flex align-items-center justify-content-center gap-2">
                                            <ArchiveFill /><Badge bg="light" text="dark">{orderDraft.length || 0}</Badge>
                                        </span>
                                    </Button>
                                    <Button variant="success" style={{ height: "37.5px" }} disabled={!totalQuantity} onClick={() => handleChartShow(true)}>
                                        <span className="d-flex align-items-center justify-content-center gap-2">
                                            <Basket2Fill /><Badge bg="light" text="dark">{totalQuantity}</Badge>
                                        </span>
                                    </Button>
                                </div>
                            </header>
                            <main>
                                {productData?.data?.length === 0 && (productData?.data?.filter(item => item.stock > 0).length === 0 || productData?.message) && (
                                    <h6 className="w-100 text-center">{productData.message || "No products found."}</h6>
                                )}

                                {productData?.data?.length > 0 && productData?.data?.filter(item => item.stock > 0).map((item, index) => (
                                    <div key={index} className={`product-card ${isLoading ? "disabled" : "enabled"}`}>
                                        <div className="product-card-image">
                                            <img src={process.env.REACT_APP_API_URL + '/storage/products/' + item.image} alt="" />
                                        </div>
                                        <div className="product-card-body" onClick={() => addProductToChart(item.id)}>
                                            <div>
                                                <h6>{item.name}</h6>
                                                <p>{item.sku}</p>
                                            </div>
                                            <div>
                                                <h6>{formatRupiah(item.price)}</h6>
                                                <p>{item.stock} {item.uom}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </main>
                        </>
                    ) : (
                        <>
                            <header>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "24px" }} />
                                </Placeholder>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "250px", height: "32px" }} />
                                    </Placeholder>
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "56px", height: "32px" }} />
                                    </Placeholder>
                                </div>
                            </header>
                            <main>
                                {Array.from({ length: 10 }).map((_, index) => (
                                    <div key={index} className="product-card">
                                        <Placeholder className="product-card-image" animation="glow">
                                            <Placeholder style={{ borderRadius: "8px",  width: "64px", height: "64px" }} />
                                        </Placeholder>
                                        <div className="product-card-body">
                                            <div className="d-flex flex-column">
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "16px" }} />
                                                </Placeholder>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </div>
                                            <div className="d-flex flex-column">
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "16px" }} />
                                                </Placeholder>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </main>
                            <footer>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "4px",  width: "150px", height: "38px" }} />
                                </Placeholder>
                            </footer>
                        </>
                    )}
                </div>
            </div>

            {/* Order Draft */}
            <Modal id="order-draft" show={draftShow} onHide={() => setDraftShow(false)} centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Order Draft</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <main>
                        {orderDraft?.message && <h6>{orderDraft.message}</h6>}

                        {orderDraft.length > 0 && orderDraft.map((item, index) => (
                            <div key={index} className="order-card" onClick={() => handleOpenDraft(item)}>
                                <div className="order-card-image">
                                    <h6>#{item.id}</h6>
                                </div>
                                <div className="order-card-body">
                                    <div>
                                        <p>{formatRupiah(calculateTotal(item.products))} ({item.payment})</p>
                                        <Badge bg={item.status === "pending" ? "warning" : item.status === "failed" ? "danger" : "success"}>{item.status}</Badge>
                                    </div>
                                    <div>
                                        <p>{item.description ? item.description.slice(0, 16) + "..." : "-"}</p>
                                        <p>{formatDateTime(item.created_at)}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </main>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setDraftShow(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* End of Order Draft */}

            {/* Chart Modal */}
            <Modal show={chartShow.status} onHide={() => handleChartShow(false)} centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Chart {chartShow.draft_id && `(DRAFT#${chartShow.draft_id})`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Order Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter Order Description" value={orderDescription} onChange={(e) => setOrderDescription(e.target.value)} disabled={isLoading} />
                        {alertMessage?.description && <Form.Text className="text-danger">{alertMessage.description}</Form.Text>}
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Order Payment</Form.Label>
                        <Form.Select value={orderPayment} onChange={(e) => setOrderPayment(e.target.value)} disabled={isLoading}>
                            <option value="cash">Cash</option>
                            <option value="transfer">Transfer</option>
                            <option value="credit">Credit</option>
                        </Form.Select>
                        {alertMessage?.payment && <Form.Text className="text-danger">{alertMessage.payment}</Form.Text>}
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Order Status</Form.Label>
                        <Form.Select value={orderStatus} onChange={(e) => setOrderStatus(e.target.value)} disabled={isLoading}>
                            <option value="success">Success</option>
                            <option value="pending">Pending</option>
                            <option value="failed">Failed</option>
                        </Form.Select>
                        {alertMessage?.status && <Form.Text className="text-danger">{alertMessage.status}</Form.Text>}
                    </Form.Group>

                    <p className="mb-2 fw-semibold" onClick={() => console.log(chartData)}>Order Product</p>
                    <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                        {chartData?.map((item, index) => {
                            const selectedProduct = productData?.data?.find(product => product.id === Number(item.product_id));
                            return (
                                <React.Fragment key={index}>
                                    <div className="product-card">
                                        <div className="product-card-image">
                                            <img src={process.env.REACT_APP_API_URL + '/storage/products/' + selectedProduct?.image} alt="" />
                                        </div>
                                        <div className="product-card-body">
                                            <div>
                                                <h6>{selectedProduct?.name}</h6>
                                                <p>{Number(item.product_quantity)} x {formatRupiah(selectedProduct?.price)} = {formatRupiah(Number(item.product_quantity) * selectedProduct?.price)}</p>
                                            </div>
                                            <div>
                                                <InputGroup size="sm">
                                                    <Button variant="outline-secondary" disabled={isLoading} onClick={() => decreaseQuantity(Number(item.product_id))}><Dash /></Button>
                                                    <Form.Control type="number" min={0} max={selectedProduct?.stock} value={Number(item.product_quantity)} onChange={(e) => handleQuantityChange(Number(item.product_id), e.target.value)} className="text-center" disabled={isLoading} />
                                                    <Button variant="outline-secondary" disabled={isLoading || Number(item.product_quantity) >= selectedProduct?.stock} onClick={() => increaseQuantity(Number(item.product_id))}><Plus /></Button>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>

                                    {["id", "product_id", "quantity", "product_quantity"].map((field) => alertMessage?.[`product.${index}.${field}`]?.[0] && (
                                        <Form.Text key={field} className="text-danger">
                                            {alertMessage[`product.${index}.${field}`][0]}
                                        </Form.Text>
                                    ))}
                                </React.Fragment>
                            );
                        })}
                    </div>

                    <p className="mt-3 mb-2 fw-semibold">Chart Menu</p>
                    <Button className="w-100 mb-2" variant="warning" disabled={isLoading} onClick={handleSaveDraft}>
                        {isLoading && <Spinner size="sm" className="me-2" />}
                        {chartShow.draft_id ? "Save Changes" : "Save as Draft"}
                    </Button>
                    {chartShow.draft_id && (
                        <Button className="w-100 mb-2" variant="danger" disabled={isLoading} onClick={handleRemoveDraft}>
                            {isLoading && <Spinner size="sm" className="me-2" />}
                            Remove Draft
                        </Button>
                    )}
                    <Button className="w-100" variant="danger" disabled={isLoading} onClick={handleResetChart}>
                        {isLoading && <Spinner size="sm" className="me-2" />}
                        Reset Chart
                    </Button>
                </Modal.Body>
                <Modal.Footer>
                    <h5 className="modal-footer-total">{formatRupiah(calculateTotal(chartData))}</h5>

                    <Button variant="primary" disabled={isLoading} onClick={() => handleCheckout(chartShow.draft_id)}>
                        {isLoading && <Spinner size="sm" className="me-2" />}
                        Checkout
                    </Button>
                    <Button variant="secondary" onClick={() => handleChartShow(false)}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* End of Chart Modal */}

            {/* Receipt Modal */}
            <Modal id="receipt-modal" show={receiptShow} onHide={() => setReceiptShow(false)} centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Receipt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body-header">
                        <img src={imageLogo} alt="Aulia Printing" />
                    </div>
                    <hr className="divider" />
                    <div className="d-flex align-items-center justify-content-between">
                        <p>{formatDateTime(orderData?.created_at)}</p>
                        <p>ORDER#{orderData?.id}</p>
                    </div>
                    <hr className="divider" />
                    <div className="d-flex flex-column gap-2">
                        {orderData?.order_products?.map((item, index) => (
                            <div key={index}>
                                <h6>{item.product_name}</h6>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>{item.product_quantity} x {formatRupiah(item.product_price)}</p>
                                    <p>{formatRupiah(item.product_quantity * item.product_price)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr className="divider" />
                    <div className="d-flex align-items-center justify-content-between">
                        <p>Total</p>
                        <p>{formatRupiah(calculateTotal(orderData?.order_products))}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <p>Paid ({orderData?.payment})</p>
                        <p>{formatRupiah(orderData?.down_payment)}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <p>Change</p>
                        <p>{formatRupiah(orderData?.down_payment - calculateTotal(orderData?.order_products))}</p>
                    </div>

                    <hr className="divider" />

                    {orderData?.description && <p className="mt-2 text-center">{orderData?.description}</p>}

                    <p className="mt-3 text-center">Thank you for your purchase! We look forward to serving you again.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleOrderReceiptPrint(orderData)}>Print</Button>
                    <Button variant="secondary" onClick={() => setReceiptShow(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
            {/* End of Receipt Modal */}
        </section>
    )
}

export default PageOrdersStore